module.exports = __webpack_public_path__ + "img/梨园乡.ac16be19.png";